 // /home/clement/compta-app/client/src/components/Finance/Investissements

 import React from "react";

const Webhooks = () => {
  return (
    <div className="ajouter-depense">
      <h2>Ajouter une dépense</h2>
      <p>Formulaire pour enregistrer une nouvelle dépense.</p>
    </div>
  );
};

export default Webhooks;